export interface UpdateUserInterestsPayload {
  NoChild: boolean;
  ChildrenYearOfBirth: number[];
  InterestIds: number[];
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const createUpdateUserInterestsPayload = (getUserInterestsData: any): UpdateUserInterestsPayload => {
  return {
    NoChild: getUserInterestsData.NoChild,
    ChildrenYearOfBirth: getUserInterestsData.ChildrenYearOfBirth,
    InterestIds: getUserInterestsData.Interests.map((interest: { Id: number }) => interest.Id),
  };
};
